import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { store } from '../App';
import { logout, storeToken } from '../features/auth/authSlice';
import { RootState } from '../reducers';
import { API_URL } from './audiencerate';
import { Auth0Service } from './auth0Service';

export const axiosClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

axiosClient.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const token = (store.getState() as RootState).auth.token;

    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config as AxiosRequestConfig;

    if (error.response?.status === 401 || error.response?.status === 403) {
      try {
        const newToken = await Auth0Service.getAccessTokenSilently({ cacheMode: 'off' });

        if (newToken) {
          store.dispatch(storeToken(newToken));

          if (originalRequest.headers) {
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          }

          return axiosClient(originalRequest);
        } else {
          store.dispatch(logout());
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        store.dispatch(logout());
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
